import axios from '../../../api/transaction_api';

export const aiStatus = async (vendor) => {
    let result = 0;
    if (vendor === "OPENNET") {
        let e = await axios.get("/v2/accessinventory/status?vendor=ENIIG");
        let s = await axios.get("/v2/accessinventory/status?vendor=SYDENERGI");
        let n = await axios.get("/v2/accessinventory/status?vendor=NORDENERGI");
        let t = await axios.get("/v2/accessinventory/status?vendor=THYMORS");
        result = e.data + s.data + n.data + t.data;
    } else if (vendor === "COAX") {
        let r = await axios.get(`/v2/accessinventory/status?vendor=PRIVATE&uniqueKey=TDC_COAX`);
        result = r.data;
    } else if (vendor === "FIBER") {
        let r = await axios.get(`/v2/accessinventory/status?vendor=TDC&uniqueKey=TDC_FIBER`);
        result = r.data;
    } else if (vendor === "MOBILE") {
        let r = await axios.get(`/v2/accessinventory/status?vendor=TDC&uniqueKey=TDC_MOBILE`);
        result = r.data;
    } else if (vendor === "COPPER") {
        let r = await axios.get(`/v2/accessinventory/status?vendor=TDC&uniqueKey=TDC_Copper`);
        result = r.data;
    } else {
        let r = await axios.get(`/v2/accessinventory/status?vendor=${vendor}`);
        result = r.data;
    }
    return result;
}

export const stagingStatus = async (vendor) => {
    let result = 0;
    let r = await axios.get(`/v2/whiteListStaging/status?vendor=${vendor}`);
    result = r.data;
    return result;
}

let uploadUrl = {
    EWII: "/v1/whiteList/ewii/upload",
    FIBER: "/v1/whiteList/tdcnet/upload",
    COPPER: "/v1/whiteList/tdcnet/upload",
    MOBILE: "/v1/whiteList/tdcnet/upload",
    COAX: "/v1/whiteList/tdcnetcoax/upload",
    OPENNET: "/v1/whiteList/loadOpenNetWhiteList",
    FIBIA: "/v1/whiteList/fibia/upload"
}

let fileValidate = {
    FIBER: "FiberAddressList",
    COPPER: "CopperAddressList",
    MOBILE: "MobileAddressList",
    EWII: "EWII_Whitelist",
    OPENNET: "SP01",
    FIBIA: "ADDRESS_",
    COAX: "CoaxAddressList_Nuuday"
}

export const fileUpload = async (vendor, file) => {
    console.log(vendor);
    console.log(file);
    if (file.name.includes(fileValidate[vendor])) {
        let formData = new FormData();
        formData.append("file", file);
        try {
            await axios.post(uploadUrl[vendor], formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                }
            });
            console.log("check Done");
            return "Done";
        } catch (e) {
        console.log("check error");
            return "Error";
        }
    } else {
        return "Invalid file";
    }

}
